module.exports = __webpack_public_path__ + "static/media/aspect.03c5d026.jpg";